import React from "react";
import Navbar from "../components/Navbar";
import CreateUserForm from "./components/CreateUserForm";

export default function CreateUser(props) {
  const current_user = props.current_user;

  return (
    <div className="min-h-full bg-gray-50">
      <div className="pb-20">
        <Navbar props={props} />
      </div>

      {/* Основной контент */}
      <main>
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
          <CreateUserForm divisions={props.divisions} />
        </div>
      </main>
    </div>
  );
}
